import React from 'react';
import { Row, Col } from 'antd';
import { BarChartOutlined, TrophyOutlined } from '@ant-design/icons';
import StatsCard from '../../components/shared/StatsCard';
import { LibraryStatistics } from '../../types';
import { calculateOverviewStats, calculateCoverageProgress } from '../utils/statisticsUtils';

interface OverviewTabProps {
  stats: LibraryStatistics;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ stats }) => {
  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <StatsCard
          title="Library Overview"
          icon={<BarChartOutlined />}
          stats={calculateOverviewStats(stats)}
        />
      </Col>
      <Col span={24}>
        <StatsCard
          title="Coverage & Utilization"
          icon={<TrophyOutlined />}
          progress={calculateCoverageProgress(stats)}
        />
      </Col>
    </Row>
  );
};

export default OverviewTab; 